import { StylistState } from '@drycut/graphql';
import { Heading, Stack } from '@drycut/ui-components';

import { CustomerBox } from '../CustomerBox';
import { CuttingTime } from '../CuttingTime';
import { ServiceStartReminder } from '../ServiceStartReminder';
import { StylistActions } from '../StylistActions';
import { useStylistCardContext } from '../StylistCardContext';
import Avatar from './Avatar';

export function StylistCard(): React.ReactNode {
  const { stylist, actionsOpen, toggleActions } = useStylistCardContext();

  if (!stylist) return null;

  return (
    <div
      className="cursor-pointer bg-zinc-50 hover:bg-zinc-100 active:bg-primary-600/10 p-4 w-64 shadow"
      onClick={toggleActions}
    >
      <Stack className="items-center gap-4">
        <Heading variant="h4" className="opacity-60">
          {stylist.name}
        </Heading>

        <Avatar stylist={stylist} />

        <CustomerBox
          booking={stylist?.currentServiceExecution?.booking}
          customer={stylist?.currentServiceExecution?.customer}
        />

        <CuttingTime stylist={stylist} />

        <StylistActions open={actionsOpen} stylist={stylist} />

        {stylist.state === StylistState.WaitingCustomer && (
          <ServiceStartReminder stylist={stylist} />
        )}
      </Stack>
    </div>
  );
}
